<!-- App Header - Fixed top bar -->
<app-header
  [logoUrl]="common.getselectedSectionGroupLogoUrl()"
  [workspaceName]="selectedSectionGroup?.name ?? ''"
  [userName]="loginUser.loginUserName ?? ''"
  [userRole]="loginUserJob || 'グループ管理者'"
  [showHamburger]="true"
  [showHelp]="false"
  [sidenavCollapsed]="isSidenavCollapsed()"
  (hamburgerClick)="toggleSelf()"
  (logoutClick)="logout()"
  (themeToggle)="toggleTheme()">
  <!-- Workspace selector in header (mat-select style matching home-nav) -->
  <mat-select workspaceSelector
              #sectionGroupSelect
              class="section-select"
              [class.section-select--expanded]="isSectionSelectExpanded"
              [value]="selectedSectionGroup"
              [compareWith]="sectionGroupComparison"
              (selectionChange)="switchSectionGroup($event)"
              (mousedown)="onSectionSelectMousedown($event)"
              (closed)="onSectionSelectClosed()"
              panelClass="section-select-panel"
              [hideSingleSelectionIndicator]="false">
    <mat-select-trigger>
      <div class="section-select__trigger" (pointerdown)="onTriggerPointerDown($event)">
        <mat-icon class="trigger-icon">apartment</mat-icon>
        <span class="trigger-name">{{ selectedSectionGroup?.name }}</span>
        <mat-icon class="trigger-arrow">arrow_drop_down</mat-icon>
      </div>
    </mat-select-trigger>
    @for (sectionGroup of administrateredSectionGroups; track sectionGroup.id) {
      <mat-option [value]="sectionGroup">
        {{ sectionGroup.name }}
      </mat-option>
    }
  </mat-select>
  <!-- Profile menu items -->
  @if (systemAdminRole || distributorAgentRole) {
    <button profileMenuItems mat-menu-item (click)="openNewWindow('/system-admin/section-groups')">
      <mat-icon>admin_panel_settings</mat-icon>
      <span i18n="@@adminSectionGroup.nav.menu.systemAdmin">システム管理</span>
    </button>
  }
  @if (selectedSection != null) {
    <button profileMenuItems mat-menu-item [routerLink]="['/section-admin', selectedSection.id, 'home']">
      <mat-icon>assignment_ind</mat-icon>
      <span i18n="@@adminSectionGroup.nav.menu.staffMenu">スタッフメニュー</span>
    </button>
  }
</app-header>

<mat-sidenav-container class="mat-sidenav-container" [class.sidenav-collapsed]="isSidenavCollapsed()" autosize>
  <mat-sidenav #drawer class="mat-sidenav" [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="!(isHandset$ | async) && IsNavSystemOpen === true">

    <div class="sidenav">
      <div class="sidenav-main">
        <!-- <ng-template [ngIf]="(recordMeasurerRole || recordRefererRole) && contractEnabled"> -->
        <div class="sidenav-content-panel">
          <!-- Menu -->
          <div class="sidenav-section">
            <h3 class="sidenav-section__title" i18n="@@adminSectionGroup.nav.section.menu">メニュー</h3>
            <div class="sidenav-menu-items">
            <div class="side_menu_item home">
              <a [routerLink]="['/section-group-admin', selectedSectionGroup?.id, 'home']"
                 routerLinkActive="selected">
                <mat-icon fontSet="material-icons-outlined">dashboard</mat-icon>
                <span i18n="@@adminSectionGroup.nav.menu.home">ダッシュボード</span>
              </a>
            </div>

            <div class="side_menu_item  user-top">
              @if (hasSectionManagement || hasAllSectionGroupManagement) {
                <a [routerLink]="['/section-group-admin', selectedSectionGroup.id, 'sections']"
                   routerLinkActive="selected">
                  <mat-icon fontSet="material-icons-outlined">apartment</mat-icon>
                  <span i18n="@@adminSectionGroup.nav.menu.sectionList">セクション</span>
                </a>
              }
            </div>

            <div class="side_menu_item data-usage">
              @if (yearOfPrevMonth != null) {
                <a [routerLink]="['/section-group-admin', selectedSectionGroup?.id, 'monthly-summaries', yearOfPrevMonth, monthOfPrevMonth]"
                   routerLinkActive="selected">
                  <mat-icon fontSet="material-icons-outlined">storage</mat-icon>
                  <span i18n="@@adminSectionGroup.nav.menu.monthlySummary">データ利用量</span>
                </a>
              }
            </div>
            </div>
          </div>

          <!-- Settings -->
          <div class="sidenav-section">
            <h3 class="sidenav-section__title" i18n="@@adminSectionGroup.nav.section.settings">設定</h3>
            <div class="sidenav-menu-items">
              <div class="side_menu_item staff">
                @if (hasSectionGroupAdminManagement || hasAllSectionGroupManagement) {
                  <a [routerLink]="['/section-group-admin', selectedSectionGroup?.id, 'admins']"
                     routerLinkActive="selected">
                    <mat-icon fontSet="material-icons-outlined">manage_accounts</mat-icon>
                    <span i18n="@@adminSectionGroup.nav.menu.groupAdmins">グループ管理者</span>
                  </a>
                }
              </div>

              <div class="side_menu_item group_settings">
                @if (hasSectionGroupUpdate || hasAllSectionGroupManagement) {
                  <a (click)="openSectionGroupDetailDialog()">
                    <mat-icon fontSet="material-icons-outlined">settings_suggest</mat-icon>
                    <span i18n="@@adminSectionGroup.nav.menu.groupSettings">グループ全体設定</span>
                  </a>
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer (hidden when collapsed) -->
      @if (!isSidenavCollapsed()) {
        <div class="sidenav-footer">
          <span class="sidenav-footer__text">© {{ year }} PLIMES Inc.</span>
        </div>
      }
    </div>
  </mat-sidenav>

<mat-sidenav-content class="mat-sidenav-content">
    <div class="main-content-area">
      <!-- Contents inside the main screen -->
      @if (error) {
        <div style="background-color: pink; font-size: 0.9em; color: darkred; font-weight: bold;">
          <div style="padding: 5px 5px 5px 5px;"> {{ errorText }} </div>
        </div>
      }
      @if (contractEnabled) {
        <div class="content">
          <router-outlet></router-outlet>
        </div>
      } @else {
        <div style="position: relative; height: calc(100vh - 64px); display: flex; align-items: center; justify-content: center;">
          <mat-spinner diameter="48"></mat-spinner>
        </div>
      }
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
<!-- ------------------------------------------------------- -->
